import React from "react"
import CustomPageHeader from "../fragments/CustomPageHeader"
import "./style.css"

function Loans({ children }) {

  return (
    <div>
      <CustomPageHeader icon='credit-card' text='Loans' />
      { children }
    </div>
  )
}

export default Loans



// WEBPACK FOOTER //
// ./src/components/Loans/index.js